/**
 * Länkar från användare och importfiler. Endast https: och http: tillåts. javascript:, data:, file:,
 * vbscript:, blob: m.fl. avvisas. Länkar hämtas aldrig automatiskt – de öppnas bara på användarens klick.
 */
export function sanitizeUrl(input: string | null | undefined): { url: string | null; rejected?: string } {
  if (!input) return { url: null };
  const trimmed = input.trim();
  if (!trimmed) return { url: null };
  if (trimmed.length > 2048) return { url: null, rejected: trimmed.slice(0, 120) + '…' };
  // Kontrolltecken och blanksteg inne i schemat är vanliga obfuskeringstrick.
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f]/.test(trimmed)) return { url: null, rejected: trimmed.slice(0, 120) };
  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return { url: null, rejected: trimmed.slice(0, 120) };
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return { url: null, rejected: trimmed.slice(0, 120) };
  if (parsed.username || parsed.password) return { url: null, rejected: trimmed.slice(0, 120) };
  return { url: parsed.toString() };
}
